import React from "react";
import { Popover } from "@blueprintjs/core";
import classNames from "classnames";
import DefaultMenu from "./Components/DefaultMenu";
import IconButton from "../IconButton";
import { fireOnEnter } from "utils/keyboard";
import ThreeDotsIcon from "icons/three-dots.svg";
import * as styles from "./styles.module.scss";
const ThreeDotsMenu = ({ popoverRef, items, disabled, name, icon, placement, isOpen, onMenuClick, setIsOpen, classes, closeOnTargetHide, usePortal = true, modifiersCustom, children, }) => (React.createElement(Popover, { ref: popoverRef, fill: true, minimal: true, placement: placement ?? "bottom-start", isOpen: isOpen, className: classNames(styles.root, classes?.className, {
        [styles.isOpen]: isOpen,
        ...(classes?.isOpenClassName ? { [classes?.isOpenClassName]: isOpen } : {}),
    }), popoverClassName: classNames(styles.popover, classes?.popoverClassName, {
        [styles["popover-inline"]]: !usePortal,
    }), content: React.createElement(DefaultMenu, { onClick: onMenuClick, className: classes?.menuClassName, items: items }), onInteraction: (nextOpenState) => isOpen && setIsOpen(nextOpenState), usePortal: usePortal, modifiers: {
        preventOverflow: {
            enabled: true,
            fn: (data) => {
                const popperInstance = data?.instance?.state?.attributes?.popper;
                const popperInstanceIsHidden = popperInstance && popperInstance["data-popper-reference-hidden"];
                if (popperInstanceIsHidden) {
                    closeOnTargetHide && closeOnTargetHide();
                }
            },
        },
        offset: { options: { offset: [0, 8] }, enabled: true },
    }, modifiersCustom: modifiersCustom }, children ? (React.createElement("div", { onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(!isOpen);
    }, onKeyDown: (e) => {
        fireOnEnter(e, () => {
            e.preventDefault();
            e.stopPropagation();
            setIsOpen(!isOpen);
        });
    } }, children)) : (React.createElement(IconButton, { disabled: disabled, showTooltipIfDisabled: true, icon: icon ?? React.createElement(ThreeDotsIcon, null), title: name ?? "", classes: { root: classNames(styles.icon, classes?.iconClassName) }, onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(!isOpen);
    }, onKeyDown: (e) => {
        fireOnEnter(e, () => {
            e.preventDefault();
            e.stopPropagation();
            setIsOpen(!isOpen);
        });
    } }))));
export default ThreeDotsMenu;
